import { InnosErrorBoundary } from '@inno-tools/container-bridge'
import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

const TimeTrackingConsentModalsContent = () => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TIMETRACKING_APP_DEV_PATH,
    'timetracking',
    './TimeTrackingConsentModals',
    'timeTrackingApp'
  )

  // @ts-expect-error: dynamic import
  const { TimeTrackingConsentModals } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          TimeTrackingConsentModals: () => <></>
        }
  return <TimeTrackingConsentModals />
}

export const TimeTrackingConsentModals = () => (
  <InnosErrorBoundary>
    <TimeTrackingConsentModalsContent />
  </InnosErrorBoundary>
)
